@use "assets/styles/abstracts/variables" as v;

.app {
  position: relative;
}

.background {
  position: absolute;
  width: 2100px;
  height: 1666px;
  left: 50%;
  transform: translateX(-50%);
  top: -412px;
  z-index: -1;
}